// The trip editor's "has unsaved changes" fingerprint (TripEdit SAVE + leave prompt). Kept in its own
// module so it can be unit-tested without loading the whole editor.
export const getComparableState = (trip) => {
    const a = {
        ...trip,
    };
    if (trip.itinerary) {
        a.itinerary = {
            ...trip.itinerary,
            days: [...trip.itinerary.days],
        };
    }
    // remove everything that is synced separately
    delete a.users;
    delete a.addons;
    delete a.booking_refs;

    // Clean tag_categories from UI-only fields that get added during component lifecycle
    if (a.tag_categories && Array.isArray(a.tag_categories)) {
        a.tag_categories = a.tag_categories.map(tc => {
            const cleanTc = { ...tc };
            delete cleanTc.idx; // Remove idx field that gets added by components
            delete cleanTc.source; // Remove UI source marker
            delete cleanTc.isOverride; // Remove UI override marker
            delete cleanTc.isInTrip; // Remove UI isInTrip marker
            return cleanTc;
        });
    }

    if (a.itinerary) {
        const days = (a.itinerary.days || []).map((day) => {
            const timeslots = (day.timeslots || []).map((timeslot) => {
                const activities = (timeslot.activities || []).map((activity) => {
                    const cleanActivity = { ...activity };
                    delete cleanActivity._changed;
                    delete cleanActivity._changed_activity;

                    // On-trip documents are synced separately: every change in the itinerary's
                    // document dialogs (edit, upload, copy, reorder, delete) is saved by its own
                    // request, so it is never an unsaved trip change. Counting it lit the trip's
                    // SAVE and the leave prompt after a dialog save until a reload (Rea, CP-8423 QA).
                    delete cleanActivity.documents;

                    return cleanActivity;
                });
                const cleanTimeslot = { ...timeslot };
                cleanTimeslot.activities = activities;
                delete cleanTimeslot._changed;
                delete cleanTimeslot.open; // Remove UI state field that gets added during render
                delete cleanTimeslot._pin_custom_number_empty; // pin_custom_number itself carries the change
                // Normalize map pin fields for payload
                if (cleanTimeslot.pin_type === 'icon') {
                    // Only one source should be set and number mode must be null
                    if (cleanTimeslot.pin_icon_key) {
                        cleanTimeslot.pin_icon_url = null;
                    } else if (cleanTimeslot.pin_icon_url) {
                        cleanTimeslot.pin_icon_key = null;
                    }
                    cleanTimeslot.pin_number_mode = null;
                } else if (cleanTimeslot.pin_type === 'numbered') {
                    // Numbered pins should not carry any icon source
                    cleanTimeslot.pin_icon_key = null;
                    cleanTimeslot.pin_icon_url = null;
                }
                return cleanTimeslot;
            });
            const cleanDay = { ...day };
            cleanDay.timeslots = timeslots;
            delete cleanDay._changed;

            // Remove fields that can be automatically modified by UI components
            // QuillEditor can create empty content as "<br>" or other HTML tags
            if (cleanDay.description === null ||
                cleanDay.description === '' ||
                cleanDay.description === '<br>' ||
                cleanDay.description === '<p><br></p>' ||
                (typeof cleanDay.description === 'string' && cleanDay.description.replace(/<[^>]*>/g, '').trim() === '')) {
                delete cleanDay.description;
            }
            if (cleanDay.duration_display === null) {
                delete cleanDay.duration_display;
            }

            return cleanDay;
        });
        a.itinerary.days = days;
    } // end if (a.itinerary)

    return JSON.stringify(a);
};
